import api from "../../api/apiArticles";

const ACTION_GET_ARTICLE_BY_ID = "articles/get/byid";
const ACTION_GET_ARTICLES = "articles/all";

let initialState = {
    data:null,
    currentArticle: null
}

let ArticleReducer = (state = initialState, action)=>{
    switch(action.type)
    {
        case ACTION_GET_ARTICLE_BY_ID:{
                let selectedArticle = state.data.filter((item)=>{
                    return item.id == action.id
                });
                return {...state, currentArticle: selectedArticle[0]}
        }
        case ACTION_GET_ARTICLES:{
            return {
                ...state,
                data: action.data
            }
        }
        default: return state;
    }
}
export default ArticleReducer;

export const ACGetArticlesById = (id) => ({
    type: ACTION_GET_ARTICLE_BY_ID,
    id: id
});

const CreateGetArticlesAC = (data) => ({
    type: ACTION_GET_ARTICLES,
    data: data
});

export function ThunkCretorGetArticles() {
    return (dispatch) => {
        api.get().then((response) => {
            if (response.status == 200) {
                let result = response.data;
                dispatch(CreateGetArticlesAC(result.value));
            }
        });
    }
}